import { render, staticRenderFns } from "./LoginData.vue?vue&type=template&id=5da010fc&scoped=true&"
import script from "./LoginData.vue?vue&type=script&lang=js&"
export * from "./LoginData.vue?vue&type=script&lang=js&"
import style0 from "./LoginData.vue?vue&type=style&index=0&id=5da010fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da010fc",
  null
  
)

export default component.exports